const Footer = () => {
  return (
    <footer className="footer">
      © 2026 New Aryaveer Senior Secondary School | All Rights Reserved
    </footer>
  );
};

export default Footer;
